import React from "react";
import { usePromptModel } from "../promptModel";
import { SearchTypeEnum, ISearchValue } from "../../../../components2/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components2/YhPageHeader";
import useMdmModel from "../../../../model/mdmModel";

export function PageHeader() {
    const { mdmCatalog, mdmBranch, mdmOrgan,entity } = useMdmModel();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePromptModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "分支编码",
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "系统名称",
            fieldName: "systemName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "功能模块",
            fieldName: "moduleName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "错误编码",
            fieldName: "errorCode",
        },        {
            type: SearchTypeEnum.Input,
            placeholder: "提示信息",
            fieldName: "promptInformation",
        },
    ]

    return (
        <YhPageHeader
            title="错误日志管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}